import { render, staticRenderFns } from "./GuestList.vue?vue&type=template&id=4b73167e&scoped=true&"
import script from "./GuestList.vue?vue&type=script&lang=js&"
export * from "./GuestList.vue?vue&type=script&lang=js&"
import style0 from "./GuestList.vue?vue&type=style&index=0&id=4b73167e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73167e",
  null
  
)

export default component.exports